module.exports = __webpack_public_path__ + "static/media/gq.db5a9df4.svg";